import React, { useEffect, useState } from 'react';

import { TrackingClass } from '../../Enums/TrackingClass';
import UndefinedContracts from './UndefinedContracts/UndefinedContracts';
import getJumpInSource from '../../common/getJumpInSource';
import postForm from '../../common/utils/postForm';
import {
    CtaButtonShowMoreLeadsContainer,
    InfoIcon,
    LoginContainer,
    LoginHeader,
    LoginIcon,
    LoginMainText,
    LoginSubText,
    LoginTitle,
    LoginWrapper,
    ManagerHeader,
    ManagerHeaderContainer,
    ManagerLeadItem,
    ManagerLeads,
    ManagerSubText,
    ManagerWrapper,
} from './StyledManagerMobile';
import { Lead as LeadModel } from '../../common/Lead';
import { MobileInfoText } from './types';
import { TileField } from '../../common/types';
import capitalizeFirstLetter from '../../../common/js/utils/capitalizeFirstLetter';
import GlobalStyle from '../GlobalStyle.mobile';

/*
 * Types
 */
type ManagerProps = {
    leads: LeadModel[];
    formDefinition: TileField[];
    debugCookie: boolean;
    isAnonymous: boolean;
    loginUrl: string;
    backUrl: string;
    infoTexts: MobileInfoText;
};

/*
 * Component
 */
const Manager: React.FC<ManagerProps> = (props) => {
    const leadsInitShow = 5;
    const {
        leads,
        debugCookie,
        formDefinition,
        isAnonymous,
        loginUrl,
        backUrl: string,
        infoTexts: { check24, provider },
    } = props;

    const [showLeads, setShowLeads] = useState(leadsInitShow);
    const source = getJumpInSource();

    const handleLeadClick = (lead: LeadModel) => {
        const { leadId, productGroup, productId } = lead;

        postForm(`/cancellation/${lead.nextStep}/?product_group=${productGroup}&product_id=${productId}&foreign_id=${leadId}`, {
            leadId,
            productGroup,
            productId,
            canSkipForm: true,
            source,
        });
    };

    const handleLoginButtonClick = () => {
        window.location.assign(loginUrl);
    };

    useEffect(() => {
        const backButton = document.querySelector('.c24m-header-back-wrapper');

        if (!backButton) {
            return;
        }

        const handleBackClick = (e: Event) => {
            e.preventDefault();

            window.location.assign(`/myleads/`);
        };

        backButton!.addEventListener('click', handleBackClick);

        return () => backButton!.removeEventListener('click', handleBackClick);
    }, []);

    const handleShowMoreLeads = () => {
        setShowLeads(showLeads + leadsInitShow);
    };

    const ch24Title = 'Über CHECK24 kündigen';

    return (
        <>
            <GlobalStyle />
            {leads.length > 0 && (
                <ManagerWrapper>
                    <ManagerHeaderContainer>
                        <ManagerHeader>{ch24Title}</ManagerHeader>
                        {check24 && <InfoIcon infoText={check24} />}
                    </ManagerHeaderContainer>

                    {leads.length > 0 && (
                        <ManagerLeads>
                            {leads?.slice(0, showLeads)?.map((lead, index) => (
                                <ManagerLeadItem
                                    debug={debugCookie}
                                    key={`manager_lead_${index}`}
                                    data={lead}
                                    onClick={handleLeadClick}
                                />
                            ))}

                            {showLeads < leads.length && (
                                <CtaButtonShowMoreLeadsContainer>
                                    <a onClick={handleShowMoreLeads}>
                                        {capitalizeFirstLetter('weitere Verträge anzeigen')}
                                    </a>
                                </CtaButtonShowMoreLeadsContainer>
                            )}
                            <ManagerSubText>- oder -</ManagerSubText>
                        </ManagerLeads>
                    )}
                </ManagerWrapper>
            )}

            {isAnonymous && (
                <LoginWrapper>
                    <LoginHeader>
                        <LoginTitle>{ch24Title}</LoginTitle>
                        {check24 && <InfoIcon infoText={check24} />}
                    </LoginHeader>
                    <LoginContainer>
                        <LoginIcon></LoginIcon>
                        <LoginMainText>
                            <a className={TrackingClass.LOGIN} onClick={handleLoginButtonClick}>
                                Melden Sie sich an
                            </a>
                            , um den CHECK24 Kündigungsservice zu nutzen.
                        </LoginMainText>
                    </LoginContainer>
                    <LoginSubText>- oder -</LoginSubText>
                </LoginWrapper>
            )}

            <UndefinedContracts
                leads={leads}
                formDefinition={formDefinition}
                title={'Direkt beim Anbieter kündigen'}
                infoTextProvider={provider}
                jumpinUrl={`/cancellation/reason/`}
            />
        </>
    );
};

export default Manager;
